import { ConsentReminderDialog } from "@jti/ui";

import { useConsentPopUp } from "@checkout-v2/shared/hooks/useConsentPopUp";
import { useCheckoutV2Configuration } from "@checkout-v2/shared/providers/CheckoutV2ConfigurationProvider";

export const ConsentReminder = () => {
  const { consentReminderPopup } = useCheckoutV2Configuration();
  const { isConsentPopUpVisible, closeConsentsPopUp } = useConsentPopUp();

  if (!consentReminderPopup?.enabled) {
    return null;
  }

  return (
    <ConsentReminderDialog
      title={consentReminderPopup.mainQuestion || ""}
      subtitle={consentReminderPopup.subtitle || ""}
      description={consentReminderPopup.description || ""}
      primaryButtonText={consentReminderPopup.yesButtonText || ""}
      secondaryButtonText={consentReminderPopup.noButtonText || ""}
      mainImage={consentReminderPopup.mainImage || ""}
      imageAltText={consentReminderPopup.imageAltText || ""}
      onPrimaryButtonClick={() => {
        consentReminderPopup.yesRedirectUrl && window.open(consentReminderPopup.yesRedirectUrl, "_blank");
        closeConsentsPopUp();
      }}
      onSecondaryButtonClick={() => {
        closeConsentsPopUp();
      }}
      isOpened={isConsentPopUpVisible}
    />
  );
};
